<div class="login-page">
  <!-- Service Unavailable Banner -->
  <div class="service-unavailable-banner" *ngIf="serviceUnavailable">
    <div class="banner-content">
      <mat-icon>cloud_off</mat-icon>
      <div class="banner-text">
        <strong>Service Unavailable</strong>
        <span
          >Unable to connect to the server. Please try again later or contact
          support.</span
        >
      </div>
      <button
        mat-icon-button
        (click)="dismissServiceError()"
        aria-label="Dismiss">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-progress-bar mode="indeterminate" color="warn"></mat-progress-bar>
  </div>

  <!-- Animated Background -->
  <div class="background-animation">
    <div class="floating-signs">
      <div class="sign sign-1"><span>FOR SALE</span></div>
      <div class="sign sign-2"><span>SOLD</span></div>
      <div class="sign sign-3"><span>TO LET</span></div>
      <div class="sign sign-4"><span>NEW</span></div>
      <div class="sign sign-5"><span>LET</span></div>
      <div class="sign sign-6"><span>AGREED</span></div>
    </div>
    <div class="grid-overlay"></div>
  </div>

  <!-- Login Card -->
  <div class="login-container">
    <div class="login-card">
      <!-- Header -->
      <div class="login-header">
        <div class="logo-container">
          <div class="logo">
            <mat-icon>real_estate_agent</mat-icon>
          </div>
        </div>
        <h1>{{ companyInfo.fullName || 'Welcome Back' }}</h1>
        <p *ngIf="companyInfo.shortName" class="subtitle">
          {{ companyInfo.shortName }}
        </p>
      </div>

      <!-- Login Form -->
      <div class="login-content">
        <form
          [formGroup]="loginForm"
          (ngSubmit)="onSubmit()"
          class="login-form">
          <h2>Sign in to your account</h2>

          <div class="form-field">
            <mat-form-field appearance="outline">
              <mat-label>Username</mat-label>
              <mat-icon matPrefix>person</mat-icon>
              <input
                matInput
                placeholder="Enter your username"
                formControlName="username"
                autocomplete="username"
                required />
              <mat-error *ngIf="!loginForm.controls.username.valid">
                Username is required
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-field">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <mat-icon matPrefix>lock</mat-icon>
              <input
                matInput
                placeholder="Enter your password"
                type="password"
                formControlName="password"
                autocomplete="current-password"
                required />
              <mat-error *ngIf="!loginForm.controls.password.valid">
                Password is required
              </mat-error>
            </mat-form-field>
          </div>

          <button
            type="submit"
            mat-raised-button
            color="primary"
            class="login-button"
            [disabled]="!loginForm.valid || isLoading"
            [attr.aria-label]="isLoading ? 'Signing in' : null">
            <ng-container *ngIf="isLoading; else loginText">
              <mat-spinner diameter="24"></mat-spinner>
            </ng-container>
            <ng-template #loginText>
              <mat-icon>login</mat-icon>
              Sign In
            </ng-template>
          </button>
        </form>
      </div>

      <!-- Footer with Contact Info -->
      <div class="login-footer" *ngIf="companyInfo.mobile || companyInfo.email">
        <p class="contact-label">Need help? Contact us</p>
        <div class="contact-info">
          <a
            *ngIf="companyInfo.mobile"
            [href]="'tel:' + companyInfo.mobile"
            class="contact-item">
            <mat-icon>phone</mat-icon>
            <span>{{ companyInfo.mobile }}</span>
          </a>
          <a
            *ngIf="companyInfo.email"
            [href]="'mailto:' + companyInfo.email"
            class="contact-item">
            <mat-icon>email</mat-icon>
            <span>{{ companyInfo.email }}</span>
          </a>
        </div>
      </div>
    </div>

    <!-- Bottom Attribution -->
    <p class="attribution">Board Management System</p>
  </div>
</div>
